export default {
  picker: {
    titleGeometries: '選擇幾何模型',
    titleMeshes: '選擇網格',
    descriptionGeometries:
      '選取要即時建立網格的幾何模型。每個項目都會在設計點矩陣中新增列。',
    descriptionMeshes:
      '選取要作為輸入的現有網格。每個項目都會在設計點矩陣中新增列。',
    searchGeometries: '搜尋幾何模型…',
    searchFiles: '搜尋檔案…',
    sortGeometries: '排序幾何模型',
    sortRecent: '最近',
    sortOldest: '最舊',
    sortAToZ: 'A → Z',
    sortZToA: 'Z → A',
    sortSmallest: '最小',
    sortLargest: '最大',
    sortTypeAToZ: '類型 A → Z',
    sortTypeZToA: '類型 Z → A',
    ascendingFlip: '遞增 — 點擊切換',
    descendingFlip: '遞減 — 點擊切換',
    sortAscending: '遞增排序',
    sortDescending: '遞減排序',
    selectedCount: '已選取 {{count}} 個',
    cancel: '取消',
    done: '完成',
    noGeometries: '找不到幾何模型。請先在 MeshGen 上傳幾何模型。',
    noMatches: '找不到「{{query}}」的相符項目',
  },
  dropzone: {
    dragDropGeometries: '拖放幾何模型，或',
    browseFiles: '瀏覽檔案',
    geometryFormats: 'STEP、STP、OBJ、STL • 每個檔案最大 1 GB',
    uploadFailed: '上傳失敗',
    uploadFailedReason: '上傳失敗：{{reason}}',
    rejectedOne: '{{name}}：類型無效或檔案過大。',
    rejectedMany: '{{count}} 個檔案遭拒 — 類型無效或檔案過大。',
    cancelUpload: '取消上傳',
    dismiss: '關閉',
  },
  tree: {
    noGeometries: '找不到幾何模型。請先在 MeshGen 上傳幾何模型。',
    filteringBy: '篩選條件：',
    clear: '清除',
    noMeshesMatch: '沒有符合 {{filters}} 的網格。',
    meshCount_one: '{{count}} 個網格',
    meshCount_other: '{{count}} 個網格',
    elements: '{{value}} 個網格單元',
    removeTagFilter: '移除「{{label}}」篩選條件',
    filterByTag: '依「{{label}}」篩選',
  },
  meshChips: {
    cfdInt: 'CFD · 內流',
    cfdExt: 'CFD · 外流',
    cht: 'CHT',
    fea: 'FEA',
    wrap: 'Wrap',
    repair: 'Repair',
    tet: 'Tet',
    hex: 'Hex',
    poly: 'Poly',
    bl: 'BL',
    tagged: '已標記',
    untagged: '未標記',
    sharedFaceJoins: '共享面 {{count}}',
    sharedFaceJoinsHint: '這些體積在面上共享網格節點，形成連續的結合介面。',
    nodeOnlyJoins: '僅節點 {{count}}',
    nodeOnlyJoinsHint: '這些體積只在邊或點相接，沒有可供面傳熱的共享面積。',
    gapContacts: '未連接配對 {{count}}',
    gapContactsHint:
      '量測到鄰近但未連接的表面；這是接觸候選，並非已啟用的綁定。',
    taggedMissingInternal: '邊界指定中缺少 {{parts}}',
    taggedMissingCht: '缺少 {{parts}}',
    roleInlet: '入口',
    roleOutlet: '出口',
    roleFluidRegion: '流體區域',
    roleSolidRegion: '固體區域',
  },
  geometryPicker: {
    title: '幾何模型',
    searchGeometries: '搜尋幾何模型…',
    noGeometries: '找不到幾何模型。請先在 MeshGen 上傳幾何模型。',
    noMatches: '找不到「{{query}}」的相符項目',
    prev: '上一頁',
    next: '下一頁',
  },
  meshDropzone: {
    uploading: '正在上傳 {{name}}…',
    uploaded: '{{name}} 已上傳',
    failed: '{{name}} 失敗',
    tryAgain: '再試一次',
    uploadFailed: '上傳失敗',
    invalidFile: '檔案類型無效或檔案過大。',
    dragDropMesh: '拖放網格檔案，或',
    browseFromFile: '從檔案瀏覽',
    unitWarning:
      '上傳的網格必須已是公尺 (SI) 單位。Khorium 不會重新縮放上傳的網格 — 以 mm 建立的網格會大 1000 倍。請在 MeshGen 產生網格以設定其單位。',
  },
  viewer: {
    selectToPreview: '從側邊欄選取檔案以預覽',
    showingCadHint: '正在顯示 CAD 三角化 — 切換至 Mesh 以檢視單元',
    showingMeshHint: '正在顯示網格 — 節點熱負載與節點選取需要網格節點',
    viewLabel: '檢視',
    autoCad: '自動 (CAD)',
    autoMesh: '自動 (Mesh)',
    cadTessellation: 'CAD 三角化',
    meshCells: '網格單元',
    previewUnsupported: '此檔案格式不支援預覽',
    previewPreparing: '正在準備幾何模型預覽…',
    previewUnavailable: '無法預覽幾何模型',
  },
  studyTree: {
    files: '檔案',
    change: '變更',
    selectFiles: '選取檔案',
    openInMeshgen: '在 MeshGen 中開啟',
    removeFromSelection: '從選取項目中移除',
    removeItem: '從選取項目中移除 {{filename}}',
    meshStatus: '網格狀態：{{status}}',
    qualityFailed: '失敗',
    qualityCancelled: '已取消',
    qualityMeshing: '建立網格中…',
    qualityNa: '品質不適用',
    qualityReady: '品質就緒',
    qualitySicn: 'SICN {{value}}',
    qualityGamma: 'Gamma {{value}}',
    qualitySkew: 'Skew {{value}}',
  },
} as const;
